import API from 'app/services/messages/newsApi'
import { NewsModel } from 'app/models/newsModel'

/**
 * Zapytania komunikatów, wspólne dla zakładki i dla modalu edycji.
 *
 * Modal ma własny kontener (`editMessageContainer`) i zapisuje ten sam zasób co lista,
 * więc klucz musi być jeden — inaczej edycja z modalu nie unieważniłaby listy pod
 * spodem i tabela pokazywałaby nieaktualny wiersz do czasu ręcznego odświeżenia.
 */
export const NEWS_KEY = ['admin', 'news'] as const

export const fetchMessages = async (): Promise<NewsModel[]> => {
  const response = await API.create().getMessages()
  return response.content.data
}

export const addMessageRequest = (message: NewsModel) =>
  API.create().addMessage(message)

export const editMessageRequest = (message: NewsModel) =>
  API.create().editMessage(message)

/** Kształt błędu, którego oczekują komponenty (sprawdzają `.error`). */
export const toActionError = (error: unknown) => ({
  error: (error as any)?.status?.data?.code,
})
